import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { ApiResponse } from '../model/Response';

export interface MenuDefinitionItem {
  id: number;
  menuId: number;
  path: string;
  title: string;
  icon: string;
  cssClass: string;
  badge: string;
  badgeClass: string;
  isExternalLink: boolean;
  groups: string[];
  submenu: MenuDefinitionItem[];
  companyName: string;
  roles: string[];
}

export interface PageAccessCheckRequest {
  menuId: number;
  path: string;
}

export interface PageAccessCheckResponse {
  hasAccess: boolean;
  signature: string;
  timestamp: number;
}

@Injectable()
export class MenuService extends BaseService {

  constructor(http: HttpClient) {
    super(http);
  }

  /**
   * Oturum açan kullanıcının erişebildiği menü öğelerini backend'den getirir.
   * Sonuç, kullanıcının Keycloak gruplarına göre sunucu tarafında filtrelenmiştir.
   */
  getMenuDefinitions(): Observable<ApiResponse> {
    return this.get<ApiResponse>('/menu/definitions');
  }

  /**
   * Verilen sayfa (path veya menuId) için kullanıcının yetkisini sorgular.
   * Her sayfa yüklenişinde çağrılır; response'ta HMAC-SHA256 imzası bulunur.
   */
  checkPageAccess(menuId: number, path: string): Observable<ApiResponse> {
    const body: PageAccessCheckRequest = { menuId, path };
    return this.post<ApiResponse, PageAccessCheckRequest>('/menu/check-access', body);
  }
}
